module.exports = __webpack_public_path__ + "static/about-hero-b7d1a848f2d37644acde6eefc36583ad.jpg";